export const JOIN_CONFIRMATION_ENDPOINT = '/api/evcharging/join-confirmation';
export const CALCULATOR_RESULT_ENDPOINT = '/api/evcharging/calculator-result';
export const STAY_UPDATED_ENDPOINT = '/api/evcharging/stay-updated';
export const SOFTWARE_FORM_ENDPOINT = '/api/evcharging/software-form';
export const CREATE_POST_COMMENT_ENDPOINT = '/api/evcharging/create_post_comment';
